import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import routes from '../routes';
import { Router } from 'react-router';
import ReactGA from 'react-ga';

export default class Root extends Component {
  componentDidMount() {
    ReactGA.initialize('UA-101609294-1');
  }

  fireTracking() {
    ReactGA.set({ page: window.location.pathname });
    ReactGA.pageview(window.location.pathname);
  }

  render() {
    const { store, history, render } = this.props;
    return (
      <Provider store={store}>
        <Router
          onUpdate={this.fireTracking}
          history={history}
          routes={routes}
          render={render}
          key={Math.random()}
        />
      </Provider>
    );
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  render: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/Root.js